import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-calendar-options-dialog',
  templateUrl: './calendar-options-dialog.component.html',
  styleUrls: ['./calendar-options-dialog.component.css']
})
export class CalendarOptionsDialogComponent implements OnInit {
  info;
  constructor(private dialog: MatDialog,
    public dialogRef: MatDialogRef<CalendarOptionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.info = data;
  }

  ngOnInit() {

  }

  isSame(){
    return moment(this.info.start).isSame(moment(this.info.end).subtract(1,'d'));
  }

  formatStart(pickuptime) {
    return moment(pickuptime).utc().format('ddd MMM DD');
  }

  formatEnd(pickuptime){
    return moment(pickuptime).utc().subtract(1,'d').format('ddd MMM DD');
  }

  cancel(){
    this.dialogRef.close('cancel');
  }

  request(){
    this.dialogRef.close('request');
  }

}
